export enum TabKeys {
	// Billing info tabs
	BILLING_ADDRESS = "billingAddress",
	SHIPPING_ADDRESS = "shippingAddress",
	BANK_ACCOUNT = "bankAccount",

	// Contact person/Member dialog tabs
	PERSON_IDENTIFICATION = "personIdentification",
	CONTACT_INFORMATION = "contactInfo",
	ADDRESS_INFORMATION = "addressInfo",
	DEPARTMENT_INFORMATION = "departmentInfo",
	ACTIONS = "actions",

	// Contact/Contractor tabs
	GENERAL_INFORMATION = "generalInfo", // also in Project
	CONTRACTED = "contracted",
	MEMBERS = "members",
	CONTACT_PERSONS = "contactPersons",
	BILLING_INFORMATION = "billingInfo",
	PAYMENT_INFORMATION = "paymentInfo",
	WORKING_CONDITIONS = "workingConditions",
	EXTERNAL_WORKING_CONDITIONS = "externalWorkingConditions",
	SALARY_INFORMATION = "salaryInformation",
	LOGIN = "login",
	ROLLING_NUMBERS = "rollingNumbers",
	BCC_LISTS = "bccLists",
	DEPARTMENTS = "departments", // only in Contractor and Time Labels
	DUNNINGS = "dunnings", // only in Contractor

	// Members tab
	CONTRACTOR_SELECTION = "contractorSelection",

	// Project tab
	AGREEMENT = "agreement",
	ACCOUNTING_INFORMATION = "accountingInformation",
	POSITION_INFORMATION = "positionInformation",
	TEMPLATE_INFORMATION = "templateInformation",

	// Invoices tab
	LAYOUT = "layout",
	LOGO = "logo",
	DOCUMENT_SETTINGS = "documentSettings",
	TABLE_SETTINGS = "tableSettings",
	HEADER_FOOTER = "headerFooter",

	// Template tabs
	CONTENT = "content",
	HEADER = "header",
	FOOTER = "footer",

	// Time Labels tabs
	TIME_LABELS = "timeLabels",
	TIME_GROUPS = "timeGroups",

	// Absence tabs
	ABSENCE = "absence",
	CALENDAR = "calendar",
	VACATION_REQUESTS = "vacationRequests",

	// Position dialog tab
	HOURLY_RATE = "hourlyRate",
	FIXED_PRICE = "fixedPrice",

	// Team Members section
	TEAM_MEMBERS = "teamMembers",
}

export enum MenuKeys {
	MAIN_FEATURES = "mainFeatures",

	FREELANCERS = "freelancers",

	DASHBOARD = "dashboard",

	PROJECTS = "projects",
	PROJECTS_LIST = "projectsList",
	PROJECTS_TIMESHEETS = "projectsTimesheets",
	PROJECTS_MONTHLY_OVERVIEW = "projectsMonthlyOverview",

	EMPLOYEES = "employees",

	CLIENTS = "clients",

	SUPPLIERS = "suppliers",

	ADMIN = "admin",
	ADMIN_LOGINS = "adminLogins",
	SUPPLIER_IMPERSONATION = "supplierImpersonation",

	CONTRACTORS = "contractors",

	SETTINGS = "settings",
	SETTINGS_ACCOUNT = "settingsAccount",
	SETTINGS_SERVICES = "settingsServices",
	SETTINGS_ACCOUNTING_PROFILES = "settingsAccountingProfiles",
	SETTINGS_DISCOUNT_PROFILES = "settingsDiscountProfiles",
	SETTINGS_ROLLING_NUMBERS = "settingsRollingNumbers",
	SETTINGS_MAIL_CONFIGURATION = "settingsMailConfiguration",

	DOCUMENT_GENERATOR = "documentGenerator",
	DOCUMENT_GENERATOR_TEMPLATES = "documentGeneratorTemplates",
	DOCUMENT_GENERATOR_INVOICES = "documentGeneratorInvoices",

	FINANCES = "finances",
	FINANCES_DASHBOARD = "financesDashboard",
	FINANCES_INVOICES = "financesInvoices",

	MY_TIME_MANAGEMENT = "myTimeManagement",
	TEAM_TIME_MANAGEMENT = "teamTimeManagement",
	TIME_MANAGEMENT_SETTINGS = "timeManagementSettings",
	TIME_MANAGEMENT = "timeManagement",
	CALENDAR = "calendar",
	TIME_BALANCES = "timeBalances",
	TIME_LABELS = "timeLabels",
	CALENDAR_EVENTS = "calendarEvents",
	WORKING_TIME_MODELS = "workingTimeModels",
	ABSENCE_REASONS = "absenceReasons",
	TIME_ENTRIES = "timeEntries",
	MY_TIME_ENTRIES = "myTimeEntries",
	TIMESHEET = "timesheet",
	ABSENCE = "absence",
	TEAM_ABSENCE = "teamAbsence",
	HR_ABSENCE = "hrAbsence",
	HR_TIME_ENTRIES = "hrTimeEntries",
	VACATION_REQUESTS = "vacationRequests",

	ACCOUNTING = "accounting",
	ACCOUNTING_ABSENCE_OVERVIEW = "accountingAbsenceOverview",

	MY_PROJECTS = "myProjects",
	MY_PROJECTS_TIME_ENTRIES = "myProjectsTimeEntries",
	MY_PROJECTS_TIMESHEETS = "myProjectsTimesheets",

	// Invoices section
	INVOICES = "invoices",
	INVOICES_DRAFT = "invoicesDraft",
	INVOICES_UNSENT = "invoicesUnsent",
	INVOICES_UNPAID = "invoicesUnpaid",
	INVOICES_OVERDUE = "invoicesOverdue",
	INVOICES_PAID = "invoicesPaid",
	INVOICES_CANCELLED = "invoicesCancelled",

	// Offers section
	OFFERS = "offers",
	OFFERS_DRAFT = "offersDraft",
	OFFERS_UNSENT = "offersUnsent",
	OFFERS_OPEN = "offersOpen",
	OFFERS_ACCEPTED = "offersAccepted",
	OFFERS_REJECTED = "offersRejected",
	OFFERS_OVERDUE = "offersOverdue",
}
